import { BodyText, FlexColumn, FlexRow, SvgIcon } from '@make-software/cspr-design';
import { HiddenText } from 'app/components/common/hidden-text/hidden-text';
import CopyIcon from 'assets/icons/ic-copy.svg';
import ShowIcon from 'assets/icons/ic-show.svg';
import HideIcon from 'assets/icons/ic-hide.svg';
import React, { useState } from 'react';
import styled from 'styled-components';

const StyledRowWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    borderRadius: '4px',
    border: '1px solid',
    borderColor: '#D2D3D9',
    padding: '8px'
  })
);

const StyledIcon = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer'
  })
);

interface HiddenCopyTextProps {
  text: string;
  label?: string;
  isHidden?: boolean;
  isCopy?: boolean;
}

export const InfoTextInput = ({ text, label, isHidden, isCopy }: HiddenCopyTextProps) => {
  const [showKey, setShowKey] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // reset after 2s
  };

  return (
    <FlexColumn gap={4}>
      {label && (
        <BodyText size={1} scale={'sm'}>
          {label}
        </BodyText>
      )}
      <StyledRowWrapper
        justify="space-between"
        align="center"
        gap={8}
        style={{
          borderColor: copied ? '#4caf50' : '#D2D3D9', // green border when copied
          transition: 'all 0.3s ease'
        }}
      >
        <FlexRow>
          <HiddenText
            text={text}
            hide={!showKey && isHidden!}
            scale="xs"
            size={3}
            dotsNumber={text.length - 8}
          />
        </FlexRow>
        <FlexRow align="start" gap={4}>
          {isCopy && <StyledIcon src={CopyIcon} onClick={handleCopy} />}
          {isHidden && (
            <StyledIcon src={showKey ? ShowIcon : HideIcon} onClick={() => setShowKey(!showKey)} />
          )}
        </FlexRow>
      </StyledRowWrapper>
      {copied && <span style={{ fontSize: 12, color: '#4caf50', marginTop: 4 }}>Copied!</span>}
    </FlexColumn>
  );
};
